export default __webpack_public_path__ + "static/media/ab-img.ecddccb7.png";